import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { APPSYNC_URL, APPSYNC_REGION, COGNITO_CONFIG } from './constants';

// Configure Amplify with Cognito Identity Pool
export const configureAmplify = () => {
  Amplify.configure({
    API: {
      GraphQL: {
        endpoint: APPSYNC_URL,
        region: APPSYNC_REGION,
        defaultAuthMode: 'iam',
      }
    },
    Auth: {
      Cognito: {
        identityPoolId: COGNITO_CONFIG.identityPoolId,
        allowGuestAccess: true,
      }
    }
  });
};